module.exports = __webpack_public_path__ + "img/icono-direccion.d59b3492.png";